// platba
function paymentForm() {
  const locale = $('#locale').val();
  let checkboxPhysicalPerson = $('#insurance_order_physicalPerson');
  let checkboxLegalPerson = $('#insurance_order_legalPerson');
  let physicalPersonData = $('.physical-person-data');
  let companyData = $('.company-data');
  checkboxLegalPerson.click(function () {
    if (checkboxLegalPerson.is(':checked')) {
      companyData.slideDown();
      physicalPersonData.slideUp();
      checkboxPhysicalPerson.prop('checked', false);
    } else {
      companyData.slideUp();
      physicalPersonData.slideDown();
      checkboxPhysicalPerson.prop('checked', true);
    }
  });

  checkboxPhysicalPerson.click(function () {
    if (checkboxPhysicalPerson.is(':checked')) {
      companyData.slideUp();
      physicalPersonData.slideDown();
      checkboxLegalPerson.prop('checked', false);
    } else {
      companyData.slideDown();
      physicalPersonData.slideUp();
      checkboxLegalPerson.prop('checked', true);
    }
  });

  let submitAndCreateNewButton = $('#submit-and-create-new');
  submitAndCreateNewButton.on('click', function (event) {
    event.preventDefault();
    window.location = $(this).data('url');
  });

  $(document).ready(function () {
    $('#insurance_order_birthDate')
      .datetimepicker({
        maxDate: moment().endOf('day'),
        locale: $('#input-locale').val(),
        useCurrent: false,
        format: 'DD.MM.YYYY',
      })
      .on('dp.change', function () {
        $('#insurance_order_birthDate').change();
      });
    if (checkboxLegalPerson.is(':checked')) {
      companyData.slideDown();
      physicalPersonData.slideUp();
    } else {
      companyData.slideUp();
      physicalPersonData.slideDown();
    }

    $('body').addClass('is-unscrollable');

    //step 5 payment
    const insuranceOrderFullName = $('#insurance_order_fullName');
    const insuranceOrderEmail = $('#insurance_order_email');
    const insuranceOrderPhone = $('#insurance_order_phoneNumber');
    const insuranceOrderAddress = $('#insurance_order_address');
    const insuranceOrderCity = $('#insurance_order_city');
    const insuranceOrderZip = $('#insurance_order_zipCode');
    const insuranceOrderBillingName = $('#insurance_order_billingName');
    const insuranceOrderBillingAddress = $('#insurance_order_billingAddress');
    const insuranceOrderBillingCity = $('#insurance_order_billingCity');
    const insuranceOrderBillingZip = $('#insurance_order_billingZipCode');
    const insuranceOrderBillingVat = $(
      '#insurance_order_vatRegistrationNumber'
    );
    const insuranceOrderBillingIco = $('#insurance_order_companyId');
    if (insuranceOrderFullName.length && locale === 'sk') {
      insuranceOrderFullName.attr('placeholder', 'napr. JÁN BEDNÁRIK');
      insuranceOrderEmail.attr('placeholder', 'vasemail@azet.sk');
      insuranceOrderPhone.attr('placeholder', 'napr. 905 405 405');
      insuranceOrderAddress.attr('placeholder', 'napr. PRIBINOVA 4');
      insuranceOrderCity.attr('placeholder', 'napr. BRATISLAVA');
      insuranceOrderZip.attr('placeholder', 'napr. 81103');
      insuranceOrderBillingName.attr('placeholder', 'napr. FIRMA s.r.o.');
      insuranceOrderBillingAddress.attr('placeholder', 'napr. PRIBINOVA 4');
      insuranceOrderBillingCity.attr('placeholder', 'napr. BRATISLAVA');
      insuranceOrderBillingZip.attr('placeholder', 'napr. 81103');
      insuranceOrderBillingVat.attr('placeholder', 'napr. SK2021112223');
      insuranceOrderBillingIco.attr('placeholder', 'napr. 2021112223');
    }
  });
}
